/* eslint-disable */
import {
  Button,
  Flex,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
} from "@chakra-ui/react";
// Custom components
import Card from "components/card/Card";
import React, { useMemo } from "react";
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";

const columns = [
  {
    Header: "Pair",
    accessor: "address",
  },
  {
    Header: "ChainId",
    accessor: "chainId",
  },
  {
    Header: "Base Symbol",
    accessor: "baseTokenSymbol",
  },
  {
    Header: "Quote Symbol",
    accessor: "quoteTokenSymbol",
  },
  {
    Header: "baseTokenName",
    accessor: "baseTokenName",
  },

  {
    Header: "quoteTokenName",
    accessor: "quoteTokenName",
  },
  {
    Header: "Status",
    accessor: "status",
  },
  {
    Header: "Action",
    accessor: "_id",
  },
];
export default function BlacklistPairTable(props: {
  tableData: any;
  onClickDel: any;
  onOpenAdd: any;
}) {
  const { tableData, onClickDel, onOpenAdd } = props;

  const data = useMemo(() => tableData, [tableData]);

  const tableInstance = useTable(
    {
      columns,
      data,
      initialState: {
        pageSize: 10,
      },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    initialState,
  } = tableInstance;
  initialState.pageSize = 99999;

  const textColor = useColorModeValue("secondaryGray.900", "white");
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");
  const bgColor = useColorModeValue("white", "navy.800");

  return (
    <Card
      flexDirection="column"
      w="100%"
      px="0px"
      maxW="98%"
      overflowX={{ base: "auto", sm: "scroll", lg: "auto" }}
    >
      <Flex px="25px" justify="space-between" mb="20px" align="center">
        <Text
          color={textColor}
          fontSize="22px"
          fontWeight="700"
          lineHeight="100%"
        >
          Blacklist Pair Trending
        </Text>
        <Button
          colorScheme="blue"
          onClick={() => {
            onOpenAdd();
          }}
        >
          Block pair
        </Button>
      </Flex>
      <Table {...getTableProps()} variant="simple" color="gray.500" mb="24px">
        <Thead>
          {headerGroups.map((headerGroup, index) => (
            <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
              {headerGroup.headers.map((column, index) => (
                <Th
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  pe="10px"
                  key={index}
                  borderColor={borderColor}
                  pos={{
                    base: column?.Header === "Action" ? "sticky" : "unset",
                  }}
                  zIndex={{
                    base: column?.Header === "Action" ? "banner" : "unset",
                  }}
                  right={{
                    base: column?.Header === "Action" ? "0px" : "unset",
                  }}
                  bgColor={bgColor}
                >
                  <Flex
                    justify="space-between"
                    align="center"
                    fontSize={{ sm: "10px", lg: "12px" }}
                    color="gray.400"
                  >
                    {column.render("Header")}
                  </Flex>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody {...getTableBodyProps()}>
          {page.map((row, index) => {
            prepareRow(row);
            return (
              <Tr {...row.getRowProps()} key={index}>
                {row.cells.map((cell, index) => {
                  let data;

                  if (cell.column.Header === "Action") {
                    data = (
                      <>
                        <Button
                          colorScheme="red"
                          mr="5px"
                          mt="5px"
                          size="sm"
                          onClick={() =>
                            onClickDel(
                              cell.row.values.address,
                              cell.row.values.chainId
                            )
                          }
                        >
                          Delete
                        </Button>
                        {"  "}
                      </>
                    );
                  } else {
                    data = (
                      <Text color={textColor} fontSize="sm" fontWeight="700">
                        {cell.value}
                      </Text>
                    );
                  }
                  return (
                    <Td
                      {...cell.getCellProps()}
                      key={index}
                      fontSize={{ sm: "14px" }}
                      minW={{ sm: "150px", md: "200px", lg: "auto" }}
                      borderColor="transparent"
                      pos={{
                        base:
                          cell.column?.Header === "Action" ? "sticky" : "unset",
                      }}
                      zIndex={{
                        base:
                          cell.column?.Header === "Action" ? "base" : "unset",
                      }}
                      right={{
                        base:
                          cell.column?.Header === "Action" ? "0px" : "unset",
                      }}
                      bgColor={bgColor}
                    >
                      {data}
                    </Td>
                  );
                })}
              </Tr>
            );
          })}
        </Tbody>
      </Table>
    </Card>
  );
}
